// BroadcastChannel no permite destinatarios: solo la donante elegida puede descifrar el nombre del canal de copia.
export const nuevasLlaves = () => crypto.subtle.generateKey({ name: 'ECDH', namedCurve: 'P-256' }, false, ['deriveKey']);
export const clavePublica = (llaves: CryptoKeyPair) => crypto.subtle.exportKey('jwk', llaves.publicKey);
async function claveCompartida(privada: CryptoKey, publica: JsonWebKey) {
  const peer = await crypto.subtle.importKey('jwk', publica, { name: 'ECDH', namedCurve: 'P-256' }, false, []);
  return crypto.subtle.deriveKey({ name: 'ECDH', public: peer }, privada, { name: 'AES-GCM', length: 256 }, false, ['encrypt', 'decrypt']);
}
export interface NombreSellado { publica: JsonWebKey; iv: number[]; cifrado: number[] }
export function nombrePrivado(): string {
  return 'kapi-sesion-copia-' + Array.from(crypto.getRandomValues(new Uint8Array(32)), n => n.toString(16).padStart(2, '0')).join('');
}
export async function sellarNombre(nombre: string, publica: JsonWebKey, contexto: string): Promise<NombreSellado> {
  const llaves = await nuevasLlaves();
  const key = await claveCompartida(llaves.privateKey, publica);
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const cifrado = await crypto.subtle.encrypt({ name: 'AES-GCM', iv, additionalData: new TextEncoder().encode(contexto) }, key, new TextEncoder().encode(nombre));
  return { publica: await clavePublica(llaves), iv: Array.from(iv), cifrado: Array.from(new Uint8Array(cifrado)) };
}
export async function abrirNombre(sellado: NombreSellado, privada: CryptoKey, contexto: string): Promise<string> {
  const key = await claveCompartida(privada, sellado.publica);
  const bytes = await crypto.subtle.decrypt({ name: 'AES-GCM', iv: new Uint8Array(sellado.iv), additionalData: new TextEncoder().encode(contexto) }, key, new Uint8Array(sellado.cifrado));
  const nombre = new TextDecoder().decode(bytes);
  if (!/^kapi-sesion-copia-[0-9a-f]{64}$/.test(nombre)) throw new Error('Canal inválido');
  return nombre;
}
